import type * as ents from '@attain-apps/entities'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /** @see {@link State.Lookup} */
  segmentInfoLookup: State.Lookup
}
export namespace State {
  export const INITIAL: NoMissing<State> = {
    segmentInfoLookup: {},
  }

  /**
   * A lookup of information about each {@link ents.core.mosaic.Page.Segment.alias}, most notably
   * featuring the {@link ents.core.mosaic.Page.Segment}
   *
   * __NOTE:__ This lookup shouldn't contain all segments,
   */
  export type Lookup = Partial<
    Record<
      ents.core.mosaic.Page.Segment['alias'],
      {
        rendering?: ents.core.mosaic.Page.Segment.Rendering
        isLoading: boolean
        error?: Error
      }
    >
  >
}
